











import { defineComponent } from '@vue/composition-api';
import { priceToString } from '@/util/CurrencyHelper';
import VehiclePopoverCell from '@/components/Comparison/VehiclePopoverCell.vue';

export default defineComponent({
    name: 'ApproxPrice',
    components: { VehiclePopoverCell },
    props: {
        amount: { type: String, required: true },
        code: { type: String, required: true },
        rate: { type: String, required: true }
    },
    computed: {
        formattedPrice: function () {
            return priceToString({
                Amount: this.amount,
                CurrencyCode: this.code,
                ToPoundRate: this.rate,
                Vat: '',
                ONO: '',
                TradeExplain: ''
            });
        },
        popoverContent: function () {
            return 'Approx. price in ' + this.code + ': ' + this.formattedPrice +
                ' (Euro to Sterling exchange rate ' + this.rate + '). The seller' +
                ' is under no obligation to accept Euro or the approximate Euro' +
                ' price listed. Any Euro price shown is a guide price only. If you would' +
                ' like to pay by Euro, please check with the seller beforehand.';
        },
        popoverIcon: () => '<i class="glyphicon cars_compare_glyphicon cars_compare_glyphicon__info"></i>'
    }
});
